
define('views/template/index',[
	"./topHeader/index",
	"./leftColumn/index",
	"./rightColumn/index",
	"text!./template.html"
	],

function(TopHeaderView, LeftColumnView, RightColumnView, template) {

	var TemplateView = Backbone.View.extend({

		initialize: function() {

			if(!this.options.admin) this.options.admin = false;

			if(this.options.admin)
				$("html").addClass("admin");

			if(this.options.fixed)
				$("html").addClass("fixed");

			// Lets add special classes for old browsers, so we can make exceptions in css
			if(!window.jsdom) {

				if(navigator.userAgent.match(/MSIE 9/)) {
					$("html").addClass("ie9 lt-ie10");
				}

				if(navigator.userAgent.match(/MSIE 10/)) {
					$("html").addClass("ie10");
				}

				if(navigator.userAgent.match(/Version\/[65]/) && navigator.userAgent.match(/Safari/)) {
					$("html").addClass("oldSafari");
				}

				var isFireFox = navigator.userAgent.toLowerCase().match(/firefox\/(.*)$/);
				if(isFireFox && parseInt(isFireFox[1]) < 21) {
					$("html").addClass("oldFirefox");
				}

			}


			// Log Image for stats.
			if(!window.jsdom && !this.options.noLogImage) {
				var path = (window.location.pathname == "/" ? "/index.php" : window.location.pathname);
				var img = new Image();
				img.src = "https://www."+window.config.rootdomain+"/logimage.php?page="+encodeURIComponent(path)+"&rnd="+Math.floor(Math.random()*1000);
			}

			// Lets only log stats from the live site.
			/* if(!window.jsdom && window.config.rootdomain == "socialpsychology.org") {
				(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
 					(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
 					m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
 				})(window,document,'script','https://www.googletagmanager.com/gtag/js?id=UA-9046968-5');
 					window.dataLayer = window.dataLayer || [];
 					function gtag(){dataLayer.push(arguments);}
 					gtag('js', new Date());

 					gtag('config', 'UA-9046968-5');
			}
			*/

			// Default options
			this.options = _.extend({
				noSearchBox: false,
				noContact: false,
				rightColumn: true,
				leftColumn: true,
				hideMaps: false
			}, this.options);


			if(!this.$("#content").length)
				this.render();

			this.topHeader = new TopHeaderView(_.extend(this.options, {el: this.$("#topHeader")}));

			if(this.options.leftColumn) {
				this.leftColumn = new LeftColumnView({
					noSearchBox: this.options.noSearchBox,
					leftColumnView: this.options.leftColumnView,
					extendLeftColumn: this.options.extendLeftColumn,
					contentEl: this.$("#content"),
					viewOptions: this.options.viewOptions,
					el: (this.$("#leftColumn").length > 0 ? this.$("#leftColumn") : $("<div id='leftColumn'></div>"))
				});
				this.$("#content").before(this.leftColumn.el);
			} else {
				$("html").addClass("noLeftColumn");
			}

			if(this.options.rightColumn) {
				this.rightColumn = new RightColumnView({
					el: (this.$("#rightColumn").length > 0 ? this.$("#rightColumn") : $("<div id='rightColumn'></div>"))
				});
				this.$("#content").after(this.rightColumn.el);
			}

		},

		render: function() {
			//console.log("RENDERING!!!: "+this.$el[0]);
			//this.$el[0].innerHTML = "aidnsaoidasidoinsainsadinoasdoniasionasdinoinaosdaniodsinoasdioasdinsdinao";
			//$("body").prepend(template);
			this.$el.prepend(template);

		}

	});

	return TemplateView;
});
